<template>
  <div class="request-home">
    <div class="video-container">
      <video id="video" autoplay loop muted>
        <source src="/dist/video/01_about.mp4" type="video/mp4">
        배경화면
      </video>
    </div>
    <div class="welcome-header"></div>
    <div class="welcome" style="z-index:2">
      <div class="box">
        <div class="box-content">
          <div class="ncp-logo">
          </div>
          <p class="welcome-title1">업무 담당자</p>
          <br/>
          <br/>
          <p>
            업무 담당자 정보를 입력해 주세요.
          </p>
          <br/>
          <br/>
          <div class="box-row">
            <!--<div class="box-label">이름</div>-->
            <!--<multiselect :value="nameValue" v-model="selectedItem" :options="empList" :custom-label="nameWithEmail" placeholder="임직원검색" track-by="empEmail" -->
            <!--deselect-label="취소"-->
            <!--select-label="선택"-->
            <!--selectedLabel="선택됨"-->
            <!--:preserve-search="true"-->
            <!--:searchable="true" :internal-search="false" :clear-on-select="false" -->
            <!--:maxHeight="200"-->
            <!--:limit="2"-->
            <!--@search-change="asyncFind"-->
            <!--@open="open"-->
            <!--&gt;-->
            <!--<template slot="singleLabel" slot-scope="{ option }"><div class="single-select-label">{{ option.empName }}({{option.empEmail.split("").map((x, i)=>i > 4 ?x :'*').join('')}})</div></template>-->
            <!--<span slot="noResult">결과가 없습니다.</span>-->
            <!--<span slot="noOptions">목록이 없습니다.</span>-->
            <!--</multiselect>-->
            <div class="box-label">이름</div>
            <input  class="box-input" type="text" v-model="item.empName"/>
          </div>
          <div class="box-row">
            <div class="box-label">이메일</div>
            <input  class="box-input" type="text" v-model="item.empEmail" @keyup.enter="getAuth()"/>
          </div>
        </div>
        <div class="box-bottom" >
          <div class="lang"><i class="icon-global"></i></div>
          <a class="btn lg white point" @click="getAuth()">확인</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Vue from 'vue'
  import Vuex from 'vuex';

  import Multiselect from 'vue-multiselect'
  Vue.use(Vuex);
  export default {
    name: "Request",
    components: {
      Multiselect
    },
    data(){
      return {
        nameValue: null,
        empList: [],
        selectedItem: null,
        selectedItems: [],
        item: {},
        isShow: true
      }
    },
    mounted(){
      this.isShow = true;
      if (screen.width > 768) {
        var mvp = document.getElementById('myViewport');
        mvp.setAttribute('content','width=device-width, initial-scale=1');
      }
    },
    methods: {
      nameWithEmail ({ empName, empEmail }) {
        var a = empEmail.split("").map((x, i)=>i > 4 ?x :'*').join('')
        return `${empName}(${a})`
      },
      open(){
        this.$nextTick(() => {
          $(".multiselect__content-wrapper").mCustomScrollbar({
            axis:" xy" // horizontal scrollbar
          })
        })
      },
      asyncFind(query){

        if(query == ''){
          this.selectedItem = null;
          this.empList = [];
          return;
        }
        if(query.length <= 1) {
          return;
        }
        var that = this;


        setTimeout(()=>{
          this.$http.get('/api/private/emp/search'+'?empName='+ query)
            .then((result) => {
              that.empList = result.data;
            }).catch((e) =>{
          })
        },1000)
      },
      getAuth(){
        var o = {empEmail: this.item.empEmail, empName: this.item.empName}
        if(this.$store.state.login.empEmail != null && this.$store.state.login.empEmail != this.item.empEmail){
          // this.$toast.error(this.$t('error.visitEmpError'));
          this.noti('경고', this.$t('error.visitEmpError'), 'danger');
          return;
        }

        var payloadString = $.param(o);
        var that = this;
        this.$http.get('/api/public/emp/auth'+'?'+ payloadString)
          .then((result) => {
            that.$store.dispatch('auth/setAuth', result.data.token);
            this.noti('인증완료', that.$t('message.welcome1'), 'success');
            // that.$toast.success(that.$t('message.welcome1'));
            const flow = this.$route.query.flow;
            const nextPath = flow === 'workPermit' ? '/app/workPermit' : '/app/main/selectIdc';
            that.$router.push({ path: nextPath })
          }).catch((e) =>{
            // that.$toast.error(that.$t('error.visitError'));
            this.noti('인증실패', that.$t('error.visitError'), 'danger');
          })
      },
    }
  };
</script>
